var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-date"},[(_vm.inline)?_c('span',{ref:"picker",staticClass:"picker"}):_c('input',{ref:"picker",staticClass:"input",attrs:{"type":"date","readonly":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }